/**
 * WatchOutIcon — Watch Out callout icon. Coral background, white warning
 * triangle with vertical bar + dot.
 *
 * Production SVG landed 2026-05-04 in
 * /design/icons/callout-watchout-warning-triangle.svg. Geometry preserved
 * from the v10 mockup reference; primitives + accessibility tags.
 */

import IconCircle from "./IconCircle.jsx";

export default function WatchOutIcon({ size = 38 }) {
  const stroke = "var(--ppr-color-background-surface)";
  return (
    <IconCircle size={size} bg="var(--ppr-color-accent-coral)">
      <svg
        width={size * 0.55}
        height={size * 0.55}
        viewBox="0 0 24 24"
        fill="none"
        role="img"
        aria-label="Watch out"
      >
        {/* Outer triangle */}
        <path
          d="M12 3 L 22 20 L 2 20 Z"
          stroke={stroke}
          strokeWidth="2.25"
          strokeLinejoin="round"
        />
        {/* Vertical bar */}
        <line
          x1="12"
          y1="9"
          x2="12"
          y2="14"
          stroke={stroke}
          strokeWidth="2.25"
          strokeLinecap="round"
        />
        {/* Dot */}
        <circle cx="12" cy="17" r="1.2" fill={stroke} />
      </svg>
    </IconCircle>
  );
}
